import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ContactData = () => {
    const { t } = useTranslation();

    return (
        <Container>
            <Row>
                <Col xs={12}>
                    <h6>{t("homePage.contact")}</h6>
                    <p>Pole Therapy by Weronika Kozanecka</p>
                </Col>
                <Col xs={{ span: 12, order: 1 }} lg={{ span: 8, order: 1 }}>
                    <p className="d-lg-none">
                        <FontAwesomeIcon icon={faLocationDot} className="me-2" />
                        Osiedle Stefana Batorego 59/4, 60-687 Poznań
                        <br />
                        Budynek: Ataner Sp. z o.o. PPB
                    </p>
                    <p className="d-none d-lg-block">
                        <FontAwesomeIcon icon={faLocationDot} className="me-2" />
                        Osiedle Stefana Batorego 59/4, 60-687 Poznań, Budynek: Ataner Sp. z o.o. PPB
                    </p>
                </Col>
                <Col xs={{ span: 12, order: 3 }} lg={{ span: 4, order: 2 }}>
                    <p>
                        <FontAwesomeIcon icon={faFacebook} className="me-2" />
                        <a href="https://www.facebook.com/poletherapybyweronikakozanecka" target="_blank" rel="noreferrer">
                            {t("homePage.onFacebook")}
                        </a>
                    </p>
                </Col>
                <Col xs={{ span: 12, order: 2 }} lg={{ span: 8, order: 3 }}>
                    <p>
                        <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                        <a href="mailto:poletherapypoznan@gmail.com">poletherapypoznan@gmail.com</a>
                    </p>
                </Col>
                <Col xs={{ span: 12, order: 4 }} lg={{ span: 4, order: 4 }}>
                    <p>
                        <FontAwesomeIcon icon={faInstagram} className="me-2" />
                        <a href="https://www.instagram.com/poletherapy_poznan/" target="_blank" rel="noreferrer">
                            {t("homePage.onInstagram")}
                        </a>
                    </p>
                </Col>
            </Row>
        </Container>
    );
};

export default ContactData;
